import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { i as injectFont, g as getLocalizedStrings, d as defineCustomElement$4 } from './rpf-dropdown2.js';
import { d as defineCustomElement$5 } from './rpf-auth2.js';
import { d as defineCustomElement$3 } from './rpf-links2.js';
import { d as defineCustomElement$2 } from './rpf-logo2.js';

const rpfNavStrings = {
	"ar-SA": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "البحوث",
	computers: "Computers",
	about: "About us",
	donate: "التَبَرُّع",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"ca-ES": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"cs-CZ": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"cy-GB": {
	learn: "Dysgu sut mae codio",
	teach: "Teaching resources",
	research: "Ymchwil",
	computers: "Computers",
	about: "About us",
	donate: "Gwneud Cyfraniad",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"da-DK": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"de-DE": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Forschung",
	computers: "Computers",
	about: "About us",
	donate: "Spenden",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"el-GR": {
	learn: "Μάθετε να προγραμματίζετε",
	teach: "Teaching resources",
	research: "Έρευνα",
	computers: "Computers",
	about: "About us",
	donate: "Δωρεές",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"en-GB": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"es-ES": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Investigación",
	computers: "Computers",
	about: "About us",
	donate: "Donar",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"es-LA": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"et-EE": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Uurimistegevus",
	computers: "Computers",
	about: "About us",
	donate: "Anneta",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"fi-FI": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"fr-CA": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Recherche",
	computers: "Computers",
	about: "About us",
	donate: "Faire un don",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"fr-FR": {
	learn: "Apprendre à coder",
	teach: "Teaching resources",
	research: "Recherche",
	computers: "Computers",
	about: "About us",
	donate: "Faire un don",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"gu-IN": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"he-IL": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"hi-IN": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"hr-HR": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Računala",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"hu-HU": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"it-IT": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Ricerca",
	computers: "Computers",
	about: "About us",
	donate: "Dona",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"ja-JP": {
	learn: "コーディングを学ぶ",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "寄付する",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"kn-IN": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"ko-KR": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"lt-LT": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Tyrimas",
	computers: "Computers",
	about: "About us",
	donate: "Paaukoti",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"lv-LV": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Pētniecība",
	computers: "Computers",
	about: "About us",
	donate: "Ziedot",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"me-ME": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"mr-IN": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"ms-MY": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Penyelidikan",
	computers: "Computers",
	about: "About us",
	donate: "Derma",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"nl-NL": {
	learn: "Leer programmeren",
	teach: "Teaching resources",
	research: "Onderzoek",
	computers: "Computers",
	about: "About us",
	donate: "Doneer",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"no-NO": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"pl-PL": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Programy badawcze",
	computers: "Computers",
	about: "About us",
	donate: "Przekaż darowiznę",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"pt-BR": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"pt-PT": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Pesquisa",
	computers: "Computers",
	about: "About us",
	donate: "Doar",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"ro-RO": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Cercetare",
	computers: "Computers",
	about: "About us",
	donate: "Donează",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"ru-RU": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"sk-SK": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"sl-SI": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"sr-SP": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"sv-SE": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"tr-TR": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Araştırma",
	computers: "Computers",
	about: "About us",
	donate: "Bağış yapın",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"uk-UA": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Дослідження",
	computers: "Computers",
	about: "About us",
	donate: "Пожертвувати",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"vi-VN": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"vls-BE": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"xh-ZA": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"zh-CN": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
},
	"zh-TW": {
	learn: "Learn to code",
	teach: "Teaching resources",
	research: "Research",
	computers: "Computers",
	about: "About us",
	donate: "Donate",
	"toggle-navigation-menu": "Toggle navigation menu",
	"skip-to-content": "Skip to main content",
	"skip-to-footer": "Skip to footer",
	"accessibility-statement": "Accessibility statement and help"
}
};

const rpfOrgNavCss = ":root, :host {\n  --rpf-white: hsla(0, 0%, 100%, 1);\n  --rpf-off-white: hsla(225, 25%, 97%, 1);\n  --rpf-grey-50: hsla(210, 8%, 95%, 1);\n  --rpf-grey-100: hsla(228, 10%, 90%, 1);\n  --rpf-grey-150: hsla(223, 9%, 85%, 1);\n  --rpf-grey-200: hsla(228, 10%, 80%, 1);\n  --rpf-grey-300: hsla(229, 9%, 75%, 1);\n  --rpf-grey-400: hsla(229, 8%, 61%, 1);\n  --rpf-grey-500: hsla(229, 9%, 42%, 1);\n  --rpf-grey-600: hsla(228, 9%, 32%, 1);\n  --rpf-grey-700: hsla(228, 9%, 22%, 1);\n  --rpf-grey-800: hsla(232, 9%, 18%, 1);\n  --rpf-grey-850: hsla(228, 9%, 15%, 1);\n  --rpf-grey-900: hsla(228, 9%, 10%, 1);\n  --rpf-grey-950: hsla(228, 8%, 5%, 1);\n  --rpf-black: hsla(0, 0%, 0%, 1);\n}\n\n:root, :host {\n  --rpf-text-primary: hsla(0, 0%, 13%, 1);\n  --rpf-text-primary-darkmode: var(--rpf-white);\n  --rpf-text-secondary: hsla(200, 9%, 33%, 1);\n  --rpf-text-secondary-darkmode: hsla(0, 0%, 80%, 1);\n  --rpf-link-text: var(--rpf-navy-800);\n}\n\n:root, :host {\n  --space-0-125: 0.0625rem;\n  --space-0-25: 0.125rem;\n  --space-0-5: 0.25rem;\n  --space-1: 0.5rem;\n  --space-1-5: 0.75rem;\n  --space-2: 1rem;\n  --space-3: 1.5rem;\n  --space-4: 2rem;\n  --space-5: 2.5rem;\n  --space-6: 3rem;\n  --space-7: 3.5rem;\n  --space-8: 4rem;\n  --space-9: 4.5rem;\n  --space-10: 5rem;\n}\n\n:root, :host {\n  --border-radius: var(--space-1);\n  --border-radius-sm: var(--space-0-5);\n  --border-width-sm: 1px;\n  --border-width-md: 2px;\n  --border-width-lg: 3px;\n  --alert-border-width: var(--border-width-md);\n  --fieldset-border-width: var(--border-width-md);\n  --input-border-width: var(--border-width-md);\n  --table-border-width: var(--border-width-sm);\n}\n\n:root, :host {\n  --rpf-brand-black: hsla(60, 4%, 11%, 1);\n  --rpf-brand-leaf: hsla(123, 43%, 48%, 1);\n  --rpf-brand-raspberry: hsla(342, 71%, 47%, 1);\n  --rpf-raspberry-50: hsla(338, 57%, 97%, 1);\n  --rpf-raspberry-100: hsla(342, 62%, 96%, 1);\n  --rpf-raspberry-200: hsla(344, 73%, 93%, 1);\n  --rpf-raspberry-400: hsla(341, 63%, 84%, 1);\n  --rpf-raspberry-500: hsla(343, 62%, 68%, 1);\n  --rpf-raspberry-600: hsla(343, 64%, 58%, 1);\n  --rpf-raspberry-800: hsla(342, 71%, 47%, 1);\n  --rpf-raspberry-900: hsla(340, 78%, 36%, 1);\n}\n\n:root, :host {\n  --rpf-red-100: hsla(4, 89%, 96%, 1);\n  --rpf-red-200: hsla(1, 87%, 91%, 1);\n  --rpf-red-400: hsla(1, 87%, 82%, 1);\n  --rpf-red-600: hsla(1, 87%, 72%, 1);\n  --rpf-red-800: hsla(1, 87%, 63%, 1);\n  --rpf-red-900: hsla(1, 52%, 50%, 1);\n  --rpf-green-100: hsla(125, 41%, 95%, 1);\n  --rpf-green-200: hsla(122, 39%, 87%, 1);\n  --rpf-green-400: hsla(123, 40%, 74%, 1);\n  --rpf-green-600: hsla(123, 40%, 61%, 1);\n  --rpf-green-800: hsla(123, 43%, 48%, 1);\n  --rpf-green-900: hsla(123, 43%, 34%, 1);\n  --rpf-teal-100: hsla(176, 55%, 94%, 1);\n  --rpf-teal-200: hsla(174, 55%, 85%, 1);\n  --rpf-teal-400: hsla(174, 55%, 70%, 1);\n  --rpf-teal-600: hsla(174, 56%, 56%, 1);\n  --rpf-teal-800: hsla(174, 81%, 41%, 1);\n  --rpf-teal-900: hsla(174, 81%, 27%, 1);\n  --rpf-teal-950: hsla(174, 80%, 20%, 1);\n  --rpf-orange-100: hsla(31, 100%, 95%, 1);\n  --rpf-orange-200: hsla(32, 100%, 88%, 1);\n  --rpf-orange-400: hsla(31, 100%, 77%, 1);\n  --rpf-orange-600: hsla(31, 99%, 65%, 1);\n  --rpf-orange-800: hsla(31, 99%, 54%, 1);\n  --rpf-orange-900: hsla(31, 85%, 35%, 1);\n  --rpf-yellow-100: hsla(51, 100%, 95%, 1);\n  --rpf-yellow-200: hsla(52, 100%, 87%, 1);\n  --rpf-yellow-400: hsla(51, 100%, 75%, 1);\n  --rpf-yellow-600: hsla(52, 100%, 63%, 1);\n  --rpf-yellow-800: hsla(52, 100%, 50%, 1);\n  --rpf-yellow-900: hsla(52, 100%, 26%, 1);\n  --rpf-purple-100: hsla(282, 36%, 95%, 1);\n  --rpf-purple-200: hsla(279, 38%, 87%, 1);\n  --rpf-purple-400: hsla(279, 38%, 73%, 1);\n  --rpf-purple-600: hsla(279, 37%, 60%, 1);\n  --rpf-purple-800: hsla(279, 43%, 47%, 1);\n  --rpf-purple-900: hsla(280, 43%, 37%, 1);\n  --rpf-navy-100: hsla(235, 38%, 94%, 1);\n  --rpf-navy-200: hsla(234, 38%, 84%, 1);\n  --rpf-navy-400: hsla(235, 38%, 69%, 1);\n  --rpf-navy-600: hsla(235, 38%, 53%, 1);\n  --rpf-navy-800: hsla(235, 63%, 37%, 1);\n  --rpf-navy-900: hsla(234, 63%, 30%, 1);\n  --rpf-blue-100: hsla(203, 86%, 95%, 1);\n  --rpf-blue-200: hsla(204, 88%, 87%, 1);\n  --rpf-blue-400: hsla(204, 88%, 74%, 1);\n  --rpf-blue-600: hsla(204, 89%, 60%, 1);\n  --rpf-blue-800: hsla(204, 100%, 47%, 1);\n  --rpf-blue-900: hsla(204, 99%, 37%, 1);\n}\n\n:root, :host {\n  --rpf-alert-error-highlight: hsla(0, 88%, 99%, 1);\n  --rpf-alert-error: hsla(0, 88%, 33%, 1);\n  --rpf-alert-information-highlight: hsla(225, 64%, 99%, 1);\n  --rpf-alert-information: hsla(225, 64%, 33%, 1);\n  --rpf-alert-success-highlight: hsla(136, 90%, 99%, 1);\n  --rpf-alert-success: hsla(136, 90%, 20%, 1);\n  --rpf-alert-warning-highlight: hsla(26, 70%, 99%, 1);\n  --rpf-alert-warning: hsla(26, 70%, 29%, 1);\n}\n\n:root, :host {\n  --font-size-0-5: 0.5rem;\n  --font-size-0-75: 0.75rem;\n  --font-size-1: 1rem;\n  --font-size-1-5: 1.25rem;\n  --font-size-2: 1.5rem;\n  --font-size-3: 2rem;\n  --font-size-4: 2.5rem;\n  --font-size-5: 3rem;\n  --font-size-6: 3.5rem;\n  --font-size-7: 4rem;\n  --font-size-8: 4.5rem;\n  --font-size-9: 5rem;\n}\n\n:root, :host {\n  --font-weight-regular: 400;\n  --font-weight-bold: 700;\n}\n\n:root, :host {\n  /* 44px min-height to meet WCAG AAA target size requirements */\n  --min-target-size: 44px;\n  --sm-target-size: 32px;\n  --lg-target-size: 48px;\n}\n\n.rpf-button {\n  --rpf-button-background-color: var(--rpf-navy-800);\n  --rpf-button-background-color-hover: var(--rpf-navy-900);\n  --rpf-button-background-color-active: var(--rpf-navy-600);\n  --rpf-button-background-color-disabled: var(--rpf-grey-600);\n  --rpf-button-text-color: var(--rpf-white);\n  --rpf-button-border-color: var(--rpf-button-background-color);\n  --rpf-button-border-color-hover: var(--rpf-button-background-color-hover);\n  --rpf-button-border-color-active: var(--rpf-button-background-color-active);\n  --rpf-button-border-color-disabled: var(--rpf-button-background-color-disabled);\n  --rpf-button-danger-background-color: var(--rpf-alert-error);\n  --rpf-button-danger-background-color-hover: var(--rpf-alert-error);\n  --rpf-button-danger-background-color-active: var(--rpf-red-900);\n  --rpf-button-danger-background-color-disabled: var(--rpf-grey-600);\n  --rpf-button-danger-text-color: var(--rpf-white);\n  --rpf-button-danger-border-color: var(--rpf-button-danger-background-color);\n  --rpf-button-danger-border-color-hover: var(--rpf-button-danger-background-color-hover);\n  --rpf-button-danger-border-color-active: var(--rpf-button-danger-background-color-active);\n  --rpf-button-danger-border-color-disabled: var(--rpf-button-danger-background-color-disabled);\n  --rpf-button-border-radius: var(--border-radius);\n  --rpf-button-border-width: var(--border-width-md);\n  --rpf-button-lg-height: var(--lg-target-size);\n  --rpf-button-sm-height: var(--sm-target-size);\n  --rpf-button-min-target-size: var(--min-target-size);\n  all: unset;\n  align-items: center;\n  box-sizing: border-box;\n  color: var(--rpf-button-text-color);\n  /*\n   * We've decided to follow the masses on this and have a pointer on buttons.\n   * Google, Facebook, Twitter, Mozilla, and Microsoft amongst many others have a pointer on buttons.\n   */\n  cursor: pointer;\n  display: flex;\n  font-size: var(--font-size-1-5);\n  font-weight: var(--font-weight-bold);\n  gap: var(--space-1);\n  min-block-size: var(--rpf-button-lg-height);\n  padding: var(--space-1) var(--space-2);\n  position: relative;\n  text-align: center;\n  text-decoration: none;\n  /* Fixes a rendering error that sometimes occurs due to negative z-index */\n  transform: scale(1);\n  inline-size: fit-content;\n  /* A bit of a hack to allow for separate visual and target heights */\n}\n.rpf-button::before {\n  background-color: var(--rpf-button-background-color);\n  border-color: var(--rpf-button-border-color);\n  border-radius: var(--rpf-button-border-radius);\n  border-style: solid;\n  border-width: var(--rpf-button-border-width);\n  content: \"\";\n  display: block;\n  inset: 0;\n  position: absolute;\n  /* To ensure it renders under its siblings */\n  z-index: -1;\n}\n.rpf-button:hover::before {\n  background-color: var(--rpf-button-background-color-hover);\n  border-color: var(--rpf-button-border-color-hover);\n}\n.rpf-button:active::before {\n  background-color: var(--rpf-button-background-color-active);\n  border-color: var(--rpf-button-border-color-active);\n}\n.rpf-button:focus-visible::before {\n  outline: var(--border-width-md) solid var(--rpf-button-background-color);\n  outline-offset: 3px;\n}\n.rpf-button:disabled, .rpf-button--disabled {\n  cursor: default;\n}\n.rpf-button:disabled::before, .rpf-button:disabled:hover::before, .rpf-button--disabled::before, .rpf-button--disabled:hover::before {\n  border-color: var(--rpf-button-border-color-disabled);\n  background-color: var(--rpf-button-background-color-disabled);\n}\n.rpf-button--secondary {\n  color: var(--rpf-button-background-color);\n}\n.rpf-button--secondary::before {\n  background-color: var(--rpf-button-text-color);\n}\n.rpf-button--secondary:hover {\n  color: var(--rpf-button-background-color-hover);\n}\n.rpf-button--secondary:hover::before {\n  background-color: var(--rpf-button-text-color);\n  border-color: var(--rpf-button-border-color-hover);\n}\n.rpf-button--secondary:active {\n  color: var(--rpf-button-background-color-active);\n}\n.rpf-button--secondary:active::before {\n  background-color: var(--rpf-button-text-color);\n  border-color: var(--rpf-button-border-color-active);\n}\n.rpf-button--secondary:disabled, .rpf-button--secondary.rpf-button--disabled {\n  color: var(--rpf-button-background-color-disabled);\n}\n.rpf-button--secondary:disabled:hover::before, .rpf-button--secondary:disabled:before, .rpf-button--secondary.rpf-button--disabled:hover::before, .rpf-button--secondary.rpf-button--disabled:before {\n  background-color: var(--rpf-button-text-color);\n  border-color: var(--rpf-button-border-color-disabled);\n}\n.rpf-button--secondary.rpf-button--danger {\n  color: var(--rpf-button-danger-background-color);\n}\n.rpf-button--secondary.rpf-button--danger::before {\n  background-color: var(--rpf-button-danger-text-color);\n}\n.rpf-button--secondary.rpf-button--danger:hover {\n  color: var(--rpf-button-danger-background-color-hover);\n}\n.rpf-button--secondary.rpf-button--danger:hover::before {\n  background-color: var(--rpf-button-danger-text-color);\n  border-color: var(--rpf-button-danger-border-color-hover);\n}\n.rpf-button--secondary.rpf-button--danger:active {\n  color: var(--rpf-button-danger-background-color-active);\n}\n.rpf-button--secondary.rpf-button--danger:active::before {\n  background-color: var(--rpf-button-danger-text-color);\n  border-color: var(--rpf-button-danger-border-color-active);\n}\n.rpf-button--secondary.rpf-button--danger:disabled, .rpf-button--secondary.rpf-button--danger.rpf-button--disabled {\n  color: var(--rpf-button-danger-background-color-disabled);\n}\n.rpf-button--secondary.rpf-button--danger:disabled:hover::before, .rpf-button--secondary.rpf-button--danger:disabled:before, .rpf-button--secondary.rpf-button--danger.rpf-button--disabled:hover::before, .rpf-button--secondary.rpf-button--danger.rpf-button--disabled:before {\n  background-color: var(--rpf-button-danger-text-color);\n  border-color: var(--rpf-button-danger-border-color-disabled);\n}\n.rpf-button--tertiary {\n  color: var(--rpf-button-background-color);\n}\n.rpf-button--tertiary::before {\n  background-color: transparent;\n  border-color: transparent;\n}\n.rpf-button--tertiary:hover {\n  color: var(--rpf-button-background-color-hover);\n}\n.rpf-button--tertiary:hover::before {\n  background-color: transparent;\n  border-color: transparent;\n}\n.rpf-button--tertiary:active {\n  color: var(--rpf-button-background-color-active);\n}\n.rpf-button--tertiary:active::before {\n  background-color: transparent;\n}\n.rpf-button--tertiary:disabled, .rpf-button--tertiary.rpf-button--disabled {\n  color: var(--rpf-button-background-color-disabled);\n}\n.rpf-button--tertiary:disabled::before, .rpf-button--tertiary:disabled:hover::before, .rpf-button--tertiary.rpf-button--disabled::before, .rpf-button--tertiary.rpf-button--disabled:hover::before {\n  background-color: transparent;\n  border-color: transparent;\n}\n.rpf-button--tertiary.rpf-button--danger {\n  color: var(--rpf-button-danger-background-color);\n}\n.rpf-button--tertiary.rpf-button--danger::before {\n  background-color: transparent;\n  border-color: transparent;\n}\n.rpf-button--tertiary.rpf-button--danger:hover {\n  color: var(--rpf-button-danger-background-color-hover);\n}\n.rpf-button--tertiary.rpf-button--danger:hover::before {\n  background-color: transparent;\n  border-color: transparent;\n}\n.rpf-button--tertiary.rpf-button--danger:active {\n  color: var(--rpf-button-danger-background-color-active);\n}\n.rpf-button--tertiary.rpf-button--danger:active::before {\n  background-color: transparent;\n}\n.rpf-button--tertiary.rpf-button--danger:disabled, .rpf-button--tertiary.rpf-button--danger.rpf-button--disabled {\n  color: var(--rpf-button-danger-background-color-disabled);\n}\n.rpf-button--tertiary.rpf-button--danger:disabled::before, .rpf-button--tertiary.rpf-button--danger:disabled:hover::before, .rpf-button--tertiary.rpf-button--danger.rpf-button--disabled::before, .rpf-button--tertiary.rpf-button--danger.rpf-button--disabled:hover::before {\n  background-color: transparent;\n  border-color: transparent;\n}\n.rpf-button--danger {\n  color: var(--rpf-button-danger-text-color);\n}\n.rpf-button--danger::before {\n  background-color: var(--rpf-button-danger-background-color);\n  border-color: var(--rpf-button-danger-border-color);\n}\n.rpf-button--danger:hover::before {\n  background-color: var(--rpf-button-danger-background-color-hover);\n  border-color: var(--rpf-button-danger-border-color-hover);\n}\n.rpf-button--danger:active::before {\n  background-color: var(--rpf-button-danger-background-color-active);\n  border-color: var(--rpf-button-danger-border-color-active);\n}\n.rpf-button--danger:focus-visible::before {\n  outline: var(--border-width-md) solid var(--rpf-button-danger-background-color);\n}\n.rpf-button--icon-only {\n  block-size: var(--rpf-button-lg-height);\n  line-height: var(--rpf-button-lg-height);\n  padding: 0;\n  text-align: center;\n  inline-size: var(--rpf-button-lg-height);\n}\n.rpf-button--icon-only .rpf-button__icon {\n  margin: 0 auto;\n}\n.rpf-button--sm {\n  font-size: var(--font-size-1);\n  min-block-size: var(--rpf-button-min-target-size);\n  padding: var(--space-1) var(--space-1);\n  /* To account for 32px visual height and 44px target height */\n}\n.rpf-button--sm::before {\n  inset: calc((var(--rpf-button-min-target-size) - var(--rpf-button-sm-height)) / 2) 0;\n}\n.rpf-button--sm.rpf-button--icon-only {\n  block-size: var(--rpf-button-min-target-size);\n  line-height: var(--rpf-button-min-target-size);\n  padding: 0;\n  inline-size: var(--rpf-button-min-target-size);\n}\n.rpf-button--sm.rpf-button--icon-only::before {\n  inset: calc((var(--rpf-button-min-target-size) - var(--rpf-button-sm-height)) / 2);\n}\n.rpf-button--sm .material-symbols-sharp {\n  font-size: 20px;\n  font-variation-settings: \"OPSZ\" 20;\n}\n.rpf-button--full-width {\n  justify-content: center;\n  inline-size: 100%;\n}\n\n.rpf-burger-menu {\n  --rpf-burger-menu-background-color: var(--rpf-brand-black);\n  --rpf-burger-menu-thickness: 3px;\n  --rpf-burger-menu-inline-size: var(--space-3);\n  --rpf-burger-menu-border-radius: 0;\n  --rpf-burger-animation-speed: 150ms;\n}\n.rpf-burger-menu__button {\n  align-items: center;\n  background: transparent;\n  block-size: var(--min-target-size);\n  border: none;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  inline-size: var(--min-target-size);\n  justify-content: center;\n  padding-block: 0;\n  padding-inline: 0;\n  position: relative;\n}\n.rpf-burger-menu__button:focus-visible {\n  border-radius: var(--border-radius-sm);\n  outline: var(--border-width-md) solid var(--rpf-burger-menu-background-color);\n  outline-offset: 3px;\n}\n.rpf-burger-menu__icon, .rpf-burger-menu__icon::before {\n  background: var(--rpf-burger-menu-background-color);\n  border-radius: var(--rpf-burger-menu-border-radius);\n  display: block;\n  block-size: var(--rpf-burger-menu-thickness);\n  margin-block-start: calc(var(--rpf-burger-menu-thickness) * 1.5);\n  inline-size: var(--rpf-burger-menu-inline-size);\n  transition: opacity var(--rpf-burger-animation-speed) cubic-bezier(0, -0.55, 0.265, 1.55) 0ms, transform var(--rpf-burger-animation-speed) cubic-bezier(0, 0, 0.58, 1) 50ms, margin-inline-start var(--rpf-burger-animation-speed) cubic-bezier(0, 0, 0.58, 1) 50ms;\n  will-change: opacity, transform, margin-inline-start;\n}\n.rpf-burger-menu__icon:first-child {\n  margin-block-start: 0;\n  transform-origin: top left;\n}\n.rpf-burger-menu__icon:last-child {\n  transform-origin: bottom left;\n}\n.rpf-burger-menu__icon:nth-child(2)::before {\n  content: \"\";\n  margin-block-start: 0;\n}\n.open .rpf-burger-menu__icon {\n  opacity: 1;\n}\n.open .rpf-burger-menu__icon:first-child, .open .rpf-burger-menu__icon:last-child {\n  opacity: 0;\n}\n.open .rpf-burger-menu__icon:nth-child(2) {\n  transform: rotate(45deg);\n}\n.open .rpf-burger-menu__icon:nth-child(2)::before {\n  transform: rotate(-90deg);\n}\n@media (prefers-reduced-motion: reduce) {\n  .rpf-burger-menu__icon:first-child, .rpf-burger-menu__icon:last-child, .rpf-burger-menu__icon:nth-child(2), .rpf-burger-menu__icon:nth-child(2)::before {\n    transition: none;\n  }\n}\n\n:root, :host {\n  --line-height-0-75: 0.75rem;\n  --line-height-1: 1rem;\n  --line-height-1-5: 1.5rem;\n  --line-height-2: 2rem;\n  --line-height-2-5: 2.5rem;\n  --line-height-3: 3rem;\n  --line-height-3-5: 3.5rem;\n  --line-height-4: 4rem;\n  --line-height-4-5: 4.5rem;\n  --line-height-5: 5rem;\n  --line-height-5-5: 5.5rem;\n  --line-height-6: 6rem;\n  --line-height-6-5: 6.5rem;\n}\n\n:root, :host {\n  --link-color: var(--rpf-link-text);\n  --link-color-active: var(--rpf-navy-600);\n  --link-color-hover: var(--link-color);\n}\n\n.rpf-link {\n  border-radius: var(--border-radius);\n  color: var(--link-color);\n  cursor: pointer;\n  font-weight: var(--font-weight-bold);\n  max-inline-size: fit-content;\n}\n.rpf-link:active {\n  color: var(--link-color-active);\n}\n.rpf-link:hover {\n  color: var(--link-color-hover);\n}\n.rpf-link:focus-visible {\n  outline: 3px solid var(--link-color);\n}\n.rpf-link--block {\n  align-items: center;\n  display: flex;\n  min-block-size: var(--min-target-size);\n}\n.rpf-link--external {\n  display: inline-flex;\n  text-decoration: none;\n}\n.rpf-link--external span {\n  text-decoration: underline;\n}\n.rpf-link--external::after {\n  content: \"\\e89e\";\n  display: inline-flex;\n  font-family: \"Material Symbols Sharp\", sans-serif;\n  padding-inline-end: var(--space-0-5);\n  padding-inline-start: var(--space-0-25);\n}\n\n:host {\n  --font-family: \"Roboto\", sans-serif;\n  --rpf-grey-150-50: hsl(223deg 9% 85% / 50%);\n  font-family: var(--font-family);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n:host {\n  --nav-background: var(--rpf-white);\n  --focus-border-color: var(--rpf-brand-raspberry);\n  --text-color: var(--rpf-text-primary);\n  --button-font-size: var(--font-size-1-5);\n  position: relative;\n  z-index: 9999;\n}\n\n:host([theme=dark]) {\n  --nav-background: var(--rpf-grey-850);\n  --focus-border-color: var(--rpf-white);\n  --text-color: var(--rpf-text-primary-darkmode);\n  --link-color: var(--rpf-white);\n}\n:host([theme=dark]) .rpf-burger-menu {\n  --rpf-burger-menu-background-color: var(--rpf-white);\n}\n:host([theme=dark]) .rpf-button {\n  --rpf-button-border-color: var(--rpf-white);\n  --rpf-button-border-color-hover: var(--rpf-white);\n}\n\n.rpf-org-nav {\n  align-items: center;\n  background: var(--nav-background);\n  block-size: 64px;\n  box-sizing: border-box;\n  container-type: inline-size;\n  display: flex;\n  justify-content: space-between;\n  padding-block: var(--space-0-5);\n  padding-inline-end: var(--space-1);\n  padding-inline-start: var(--space-2);\n  position: relative;\n}\n.rpf-org-nav__nav--sm {\n  background: var(--nav-background);\n  border-block-start: 1px solid var(--rpf-grey-150-50);\n  box-sizing: border-box;\n  display: none;\n  flex-direction: column;\n  inset-block-start: 64px;\n  inset-inline: 0;\n  min-block-size: calc(100vh - 64px);\n  padding-block: var(--space-2);\n  padding-inline: var(--space-3);\n  position: absolute;\n}\n.open .rpf-org-nav__nav--sm {\n  display: flex;\n}\n.rpf-org-nav__nav--lg {\n  display: none;\n}\n@container (min-width: 77.5rem) {\n  .rpf-org-nav__nav--sm {\n    display: none;\n  }\n  .open .rpf-org-nav__nav--sm {\n    display: none;\n  }\n  .rpf-org-nav__nav--lg {\n    display: flex;\n  }\n}\n.rpf-org-nav__button {\n  font-size: var(--font-size-1-5);\n}\n.rpf-org-nav__button::before {\n  inset: calc((var(--min-target-size) - 36px) / 2) 0;\n}\n.rpf-org-nav__button:focus-visible::before {\n  outline: solid var(--border-width-md) var(--focus-border-color);\n}\n@container (max-width: 77.5rem) {\n  .rpf-org-nav__button {\n    margin-inline-start: auto;\n  }\n}\n@container (min-width: 77.5rem) {\n  .rpf-org-nav__menu {\n    display: none;\n  }\n}\n.rpf-org-nav__start-slot, .rpf-org-nav__end-slot {\n  align-items: center;\n  display: flex;\n}\n.rpf-org-nav__start-slot {\n  gap: var(--space-4);\n}\n@container (max-width: 77.5rem) {\n  .rpf-org-nav__start-slot {\n    gap: var(--space-1);\n    inline-size: 100%;\n  }\n}\n.rpf-org-nav__end-slot {\n  display: none;\n  min-inline-size: 200px;\n}\n@container (min-width: 77.5rem) {\n  .rpf-org-nav__end-slot {\n    display: flex;\n  }\n}\n\n.site-header-skipper {\n  margin: 0;\n  position: relative;\n}\n\n.site-header-skipper__item {\n  list-style: none;\n}\n.site-header-skipper__item:not(:focus-within) {\n  block-size: 1px !important;\n  clip: rect(0 0 0 0) !important;\n  clip-path: inset(100%) !important;\n  inline-size: 1px !important;\n  overflow: hidden !important;\n  position: absolute !important;\n  white-space: nowrap !important;\n}\n\n.site-header-skipper__link {\n  background: var(--nav-background);\n  font-size: var(--font-size-1-5);\n  inset-block-start: 5rem;\n  inset-inline-start: var(--space-2);\n  outline-offset: 3px;\n  padding: var(--space-1-5);\n  position: absolute;\n  z-index: 2000;\n}";
const RpfOrgNavStyle0 = rpfOrgNavCss;

const RpfOrgNav$1 = /*@__PURE__*/ proxyCustomElement(class RpfOrgNav extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.authAnchors = false;
        this.links = [
            { url: '/learn', textKey: 'learn' },
            { url: '/teach', textKey: 'teach' },
            { url: '/research', textKey: 'research' },
            { url: 'https://www.raspberrypi.com', textKey: 'computers' },
            { url: '/about', textKey: 'about' },
        ];
    }
    componentWillLoad() {
        injectFont();
        this.checkUserSession();
    }
    async componentWillRender() {
        this.linkStrings = getLocalizedStrings(this.locale, rpfNavStrings);
        this.links.map((link) => {
            link.text = this.linkStrings[link.textKey];
        });
    }
    async checkUserSession() {
        try {
            const response = await fetch('/session/logged_in');
            if (response.status === 204) {
                this.loggedIn = true;
            }
        }
        catch (error) {
            console.error('Error checking user session:', error);
        }
    }
    handleBurgerMenuClick() {
        const component = this.hostElement.shadowRoot.querySelector('.rpf-org-nav');
        component.classList.toggle('open');
    }
    rpfAuth(mobile = false) {
        return (h("rpf-auth", { locale: this.locale, logInToken: this.logInToken, signUpToken: this.signUpToken, logInTokenUrl: this.logInTokenUrl, signUpTokenUrl: this.signUpTokenUrl, loggedIn: this.loggedIn, authAnchors: this.authAnchors, logInPath: this.logInPath, logOutPath: this.logOutPath, signUpPath: this.signUpPath, hideSignUp: this.hideSignUp, hideLogIn: this.hideLogIn, hideAccountDropdown: this.hideAccountDropdown, theme: this.theme, mobileMenu: mobile }));
    }
    rpfLinks() {
        return h("rpf-links", { links: JSON.stringify(this.links) });
    }
    rpfBurgerMenu() {
        return (h("button", { class: "rpf-burger-menu__button", "aria-label": this.linkStrings['toggle-navigation-menu'], type: "button", onClick: () => this.handleBurgerMenuClick() }, h("span", { class: "rpf-burger-menu__icon", "aria-hidden": "true" }), h("span", { class: "rpf-burger-menu__icon", "aria-hidden": "true" }), h("span", { class: "rpf-burger-menu__icon", "aria-hidden": "true" })));
    }
    headerSkipper() {
        return (h("ul", { class: "site-header-skipper" }, h("li", { class: "site-header-skipper__item" }, h("a", { class: "site-header-skipper__link rpf-link", "data-event-action": "click", "data-event-category": "Header: Skip links", "data-event-label": "Skip to main content", href: "#rp-app-landmark-main" }, this.linkStrings['skip-to-content'])), h("li", { class: "site-header-skipper__item" }, h("a", { class: "site-header-skipper__link rpf-link", "data-event-action": "click", "data-event-category": "Header: Skip links", "data-event-label": "Skip to footer", href: "#rp-app-landmark-footer" }, this.linkStrings['skip-to-footer'])), h("li", { class: "site-header-skipper__item" }, h("a", { class: "site-header-skipper__link rpf-link", "data-event-action": "click", "data-event-category": "Header: Skip links", "data-event-label": "Accessibility statement and help", href: "/accessibility/" }, this.linkStrings['accessibility-statement']))));
    }
    render() {
        return (h("div", { key: 'cc28dd545d65d639a344cbc43b7840204302ee14' }, this.headerSkipper(), h("header", { key: '0725f74e4cfe8fdd9a4426e7d791892aef3f10bc', class: "rpf-org-nav" }, h("div", { key: '94c8bf620b7bbd354c94180cc814db0e0f549583', class: "rpf-org-nav__start-slot" }, h("rpf-logo", { key: '8fe983ea9d6b4aa90e08951b38651e929b2ad73d', theme: this.theme }), h("nav", { key: '2a9b238cd845448b4b12aadbfca453ac9b87ee65', class: "rpf-org-nav__nav--lg" }, this.rpfLinks()), h("a", { key: 'fc7b435968787231e1357324604cc96a168dd6cd', class: "rpf-org-nav__button rpf-button rpf-button--sm", "data-event-action": "click", "data-event-category": "Header: Navigation", "data-event-label": "Donate", "data-section": "donate", href: "/donate" }, this.linkStrings['donate']), h("div", { key: 'ba8f11dcd91284d703fddb1c999dc93b6268a589', class: "rpf-org-nav__menu rpf-burger-menu" }, this.rpfBurgerMenu())), h("div", { key: '9f9be92046a884d84f89d3ad0a6afb52da4c60cf', class: "rpf-org-nav__end-slot" }, this.rpfAuth()), h("nav", { key: '403d0fb3da77eadf935d3bf0b535f55c995602c2', class: "rpf-org-nav__nav--sm" }, this.rpfLinks(), this.rpfAuth(true)))));
    }
    get hostElement() { return this; }
    static get style() { return RpfOrgNavStyle0; }
}, [1, "rpf-org-nav", {
        "locale": [1],
        "loggedIn": [4, "logged-in"],
        "authAnchors": [4, "auth-anchors"],
        "theme": [513],
        "logInPath": [1, "log-in-path"],
        "logOutPath": [1, "log-out-path"],
        "signUpPath": [1, "sign-up-path"],
        "logInToken": [1, "log-in-token"],
        "signUpToken": [1, "sign-up-token"],
        "logInTokenUrl": [1, "log-in-token-url"],
        "signUpTokenUrl": [1, "sign-up-token-url"],
        "hideAccountDropdown": [4, "hide-account-dropdown"],
        "hideSignUp": [4, "hide-sign-up"],
        "hideLogIn": [4, "hide-log-in"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["rpf-org-nav", "rpf-auth", "rpf-dropdown", "rpf-links", "rpf-logo"];
    components.forEach(tagName => { switch (tagName) {
        case "rpf-org-nav":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RpfOrgNav$1);
            }
            break;
        case "rpf-auth":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "rpf-dropdown":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "rpf-links":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "rpf-logo":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const RpfOrgNav = RpfOrgNav$1;
const defineCustomElement = defineCustomElement$1;

export { RpfOrgNav, defineCustomElement };

//# sourceMappingURL=rpf-org-nav.js.map